<template>
  <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="25" cy="25" r="18.75" stroke="url(#paint0_linear_2356_23151)" stroke-width="2.5" />
    <path
      d="M25.0007 39.0404C25.8521 39.0404 26.5423 38.3501 26.5423 37.4987C26.5423 36.6473 25.8521 35.957 25.0007 35.957C24.1492 35.957 23.459 36.6473 23.459 37.4987C23.459 38.3501 24.1492 39.0404 25.0007 39.0404Z"
      fill="url(#paint1_linear_2356_23151)"
      stroke="url(#paint2_linear_2356_23151)"
    />
    <path
      d="M25 33.332V31.5471C25 30.0591 25.7436 28.6696 26.9817 27.8442L28.2285 27.013C30.1162 25.7546 31.25 23.636 31.25 21.3673V20.832C31.25 17.3803 28.4518 14.582 25 14.582V14.582C21.5482 14.582 18.75 17.3803 18.75 20.832V20.832"
      stroke="url(#paint3_linear_2356_23151)"
      stroke-width="2.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2356_23151"
        x1="22.358"
        y1="-4.31818"
        x2="54.7644"
        y2="3.78343"
        gradientUnits="userSpaceOnUse"
      >
        <stop class="gradient-start" offset="0" />
        <stop class="gradient-end" offset="1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2356_23151"
        x1="24.8539"
        y1="35.8699"
        x2="26.6542"
        y2="36.32"
        gradientUnits="userSpaceOnUse"
      >
        <stop class="gradient-start" offset="0" />
        <stop class="gradient-end" offset="1" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2356_23151"
        x1="24.8539"
        y1="35.8699"
        x2="26.6542"
        y2="36.32"
        gradientUnits="userSpaceOnUse"
      >
        <stop class="gradient-start" offset="0" />
        <stop class="gradient-end" offset="1" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2356_23151"
        x1="24.1193"
        y1="9.29794"
        x2="35.2864"
        y2="11.1591"
        gradientUnits="userSpaceOnUse"
      >
        <stop class="gradient-start" offset="0" />
        <stop class="gradient-end" offset="1" />
      </linearGradient>
    </defs>
  </svg>
</template>
<style lang="scss" scoped>
svg {
  width: 3.125rem;
  height: 3.125rem;
}

.gradient-start {
  stop-color: #4478ff;
}

.gradient-end {
  stop-color: #45b2ff;
}

.icon-success {
  .gradient-start {
    stop-color: #4fcd61;
  }

  .gradient-end {
    stop-color: #278f36;
  }
}

.icon-danger {
  .gradient-start {
    stop-color: #df252a;
  }

  .gradient-end {
    stop-color: #a20004;
  }
}
</style>
